import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { APP_ROUTING } from './app.routes';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';

import { NotificationService } from './services/notification.service';
import { AuthService } from './services/auth.service';
import { AuthGuardService } from './services/auth-guard.service';

import { WfNavbarComponent } from './components/webflow/wf-navbar/wf-navbar.component';
import { WfHeroComponent } from './components/webflow/wf-hero/wf-hero.component';
import { WfMainContentComponent } from './components/webflow/wf-main-content/wf-main-content.component';
import { WfCtaBannerComponent } from './components/webflow/wf-cta-banner/wf-cta-banner.component';
import { WfFooterComponent } from './components/webflow/wf-footer/wf-footer.component';

import { LoadWebflowRuntimeBundle } from './services/webflow-runtime.loader';

/**
 * @description Defers Angular bootstrap until Webflow schunks + bootstrap scripts are loaded (not part of the `scripts` bundle).
 * @return Function that returns the async load promise for `APP_INITIALIZER`.
 */
function WebflowAppInitializerFactory(): () => Promise<void> {

  return () => LoadWebflowRuntimeBundle();
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    APP_ROUTING,
    WfNavbarComponent,
    WfHeroComponent,
    WfMainContentComponent,
    WfCtaBannerComponent,
    WfFooterComponent
  ],
  providers: [
    NotificationService,
    AuthService,
    AuthGuardService,
    {
      provide: APP_INITIALIZER,
      useFactory: WebflowAppInitializerFactory,
      multi: true
    }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
